export default __webpack_public_path__ + "static/media/md.af4db83b.svg";